module.exports = __webpack_public_path__ + "static/img/children7.f91035d5.jpg";